import { useEffect, useState } from "react";

type BrowserData = {
  colorDepth: number;
  javaEnabled: boolean;
  javaScriptEnabled: boolean;
  screenHeight: string;
  screenWidth: string;
};

export const useBrowserData = () => {
  const [browserData, setBrowserData] = useState<BrowserData | null>(null);

  function collectBrowserData() {
    return {
      colorDepth: window.screen.colorDepth,
      javaEnabled: navigator.javaEnabled ? navigator.javaEnabled() : false,
      javaScriptEnabled: true,
      screenHeight: window.screen.height.toString(),
      screenWidth: window.screen.width.toString(),
      locale: navigator.language,
      timezoneOffset: new Date().getTimezoneOffset().toString(),
    };
  }

  useEffect(() => {
    const browserData = collectBrowserData();
    setBrowserData(browserData);
  }, []);

  return browserData;
};
